/**
 * Mobile sticky add-to-cart bar. Always visible, regardless of scroll
 * position. Clicking the sticky button proxies a click to the real button
 * so the existing product form (variant, quantity, validation, cart drawer)
 * is what actually runs — this file does not reimplement any cart logic.
 */
class HwStickyAtc {
  constructor(el) {
    this.el = el;
    const section = el.closest('.shopify-section');
    this.realButton = section ? section.querySelector('[ref="addToCartButton"]') : null;
    this.myButton = el.querySelector('[data-hw-sticky-atc-button]');
    this.myLabel = el.querySelector('[data-hw-sticky-atc-label]');

    if (!this.realButton || !this.myButton) return;

    this.myButton.addEventListener('click', () => {
      if (!this.realButton.hasAttribute('disabled')) {
        this.realButton.click();
      }
    });

    this.el.classList.add('hw-visible');
    this.#observeDisabled();
  }

  #observeDisabled() {
    const sync = () => {
      const disabled = this.realButton.hasAttribute('disabled');
      this.myButton.disabled = disabled;
      this.myLabel.textContent = disabled ? 'Sold out' : this.el.dataset.buttonLabel || 'Add to cart';
    };
    sync();
    const mo = new MutationObserver(sync);
    mo.observe(this.realButton, { attributes: true, attributeFilter: ['disabled'] });
  }
}

function initHwStickyAtc() {
  document.querySelectorAll('[data-hw-sticky-atc]').forEach((el) => {
    if (el.dataset.hwStickyAtcInit) return;
    el.dataset.hwStickyAtcInit = 'true';
    new HwStickyAtc(el);
  });
}

initHwStickyAtc();
document.addEventListener('shopify:section:load', initHwStickyAtc);
